export default __webpack_public_path__ + "static/media/croptop-large-back-toobig.513c0b6c.jpg";